<template>
    <div class="mcp2">
        <div class="mcp2-title1">ABOUT US</div>
        <div class="mcp2-title2">Recently Completed Projects</div>
        <div class="mcp2-cont" v-for="(item,index) in items" :key="`mobile-wustone-project-key-${index}`">
            <div class="cont-img">
                <img :src="item.CSImg" alt="">
            </div>
            <div class="cont-text">
                <div class="cont-text-title">{{item.PDTitle}}</div>
                <div class="cont-text-info" v-html="item.PDInfo"></div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "MCompanyPart2",
        components: {

        },
        data() {
            return {
                items: [{
                        CSImg: require('@/assets/CS3-1.jpg'),
                        PDTitle: 'LG U+ VR',
                        PDInfo: 'Android App 개발<br>UNITY-ANDROID PLUGIN 개발<br>Hybrid VR PLUGIN 개발'
                    },
                    {
                        CSImg: require('@/assets/CS3-2.png'),
                        PDTitle: '한화손해보험',
                        PDInfo: 'Android App 개발<br>HONE Hybrid Platform 개발'
                    },
                    {
                        CSImg: require('@/assets/CS3-3.png'),
                        PDTitle: '한국가상화폐거래소',
                        PDInfo: 'SPA 통합 플랫폼 개발<br>Vue.js 통합 라이브러리 개발'
                    },
                    {
                        CSImg: require('@/assets/CS3-4.png'),
                        PDTitle: '렌트카공제조합',
                        PDInfo: 'Android App 개발<br>Android Webview Bridge 라이브러리 개발'
                    },
                    {
                        CSImg: require('@/assets/common.png'),
                        PDTitle: 'LGU+ VR/AR 추천서비스',
                        PDInfo: 'aws personalize'
                    },
                    {
                        CSImg: require('@/assets/common.png'),
                        PDTitle: 'LGU+ 미디어 대시보드',
                        PDInfo: 'AWS quicksight'
                    },
                    {
                        CSImg: require('@/assets/common.png'),
                        PDTitle: 'LGU+ GOLF APP 개편',
                        PDInfo: 'Vue JS <br> Spring Framework'
                    },
                    {
                        CSImg: require('@/assets/miceBUSAN.png'),
                        PDTitle: '부산관광공사 메타버스',
                        PDInfo: 'Vue JS <br> Three JS <br> 전자정부 Framework'
                    },
                    {
                        CSImg: require('@/assets/golfweb.png'),
                        PDTitle: 'LGU+ GOLF WEB 개발',
                        PDInfo: 'Vue JS <br> Spring Framework'
                    },
                    {
                        CSImg: require('@/assets/common.png'),
                        PDTitle: 'LGU+ Global IDOLLIVE 개편',
                        PDInfo: 'Vue JS <br> Serverless'
                    },
                ],
            }
        }
    }
</script>
<style lang="scss" scoped>
    .mcp2 {
        width: 100%;
        padding: 20px 20px 30px 20px;
        box-sizing: border-box;
        position: relative;

        .mcp2-title1 {
            font-size: 16px;
            color: #a1a1a1;
            text-align: center;
            margin-bottom: 10px;
        }

        .mcp2-title2 {
            font-size: 20px;
            font-weight: 900;
            color: #00a79d;
            text-align: center;
            margin-bottom: 30px;
        }

        .mcp2-cont {
            width: 100%;
            margin-bottom: 30px;
            position: relative;

            .cont-img {
                width: 100%;
                position: relative;
                margin-bottom: 10px;

                img {
                    width: 100%;
                }
            }

            .cont-text {
                display: flex;
                flex-direction: column;
                align-items: center;

                .cont-text-title {
                    font-size: 18px;
                    color: rgb(240, 51, 89);
                    font-weight: 900;
                }

                .cont-text-info {
                    margin-top: 15px;
                    color: #6b6b6b;
                    text-align: center;
                }
            }
        }

        .mcp2-btn {
            width: 100%;
            text-align: center;
            margin-bottom: 50px;

            span {
                font-size: 16px;
                color: #ffffff;
                padding: 15px 50px;
                background-color: #00a79d;
                border-radius: 30px;
            }

        }
    }
</style>